<template>
<v-card flat class="grey lighten-2" >

  <member-actions-toolbar
    icon="mdi-clock"
    :title="`${fullName}'s operation hours`"
    :practitioner="practitioner"
    :member.sync="member"
    @close="$emit('close')" >

    <v-btn @click="lookup" :loading="global.request.lookups.loading" icon >
      <v-icon>mdi-refresh</v-icon>
    </v-btn>

  </member-actions-toolbar>

  <request-status :request="global.request.lookups" />
  <v-divider/>

  <template v-if="member && member.id" >

    <template v-for="location in locations" >
      <member-location-hours class="ma-4"
        :key="location.id"
        :location="location"
        :practitioner="practitioner"
        :spaceId="member.service" />
    </template>

  </template>
  <div v-else class="text-h6 pa-4" >
    <v-icon>mdi-information</v-icon>
    Choose a space above to edit {{fullName}}'s operating hours for that space
  </div>

</v-card>
</template>
<script>
import { mapGetters } from 'vuex'
// import HoursView from '@/views/space/operationhours/HoursView.vue'
import MemberLocationHours from './MemberLocationHours.vue'
import MemberActionsToolbar from './MemberActionsToolbar.vue'
export default {
  name: 'MemberHours',
  components: {
    // HoursView,
    MemberActionsToolbar,
    MemberLocationHours
  },
  props: {
    practitioner: { type: Object },
    spaceId: { type: [Number, String] },
    withClose: { type: Boolean, default: false }
  },
  data () {
    return {
      member: null
    }
  },
  mounted () {
    this.lookup()
  },
  methods: {
    getHours(hrs, practitioner) {
      return hrs.find((hr) => {
        return hr.practitioner === practitioner.user.id
      })
    }
  },
  computed: {
    ...mapGetters('identity', ['getSpaceById', 'getLocationsBySpaceId', 'getLocationBySpaceAndId', 'lookups']),
    practitionerId () {
      let id = null
      if (this.practitioner) {
        id = this.getObjectPath(this.practitioner, 'user.id')
        if (!id) {
          id = this.practitioner.id
        }
      }
      return id
    },
    spaceLocations () {
      return this.getLocationsBySpaceId(this.spaceId)
    },
    fullName () {
      let fn = this.getObjectPath(this.practitioner, 'user.first_name')
      let ln = this.getObjectPath(this.practitioner, 'user.last_name')
      return `${fn} ${ln}`
    },
    memberships () {
      return this.getObjectPath(this.practitioner, 'memberships', [])
    },
    locations () {
      // return this.lookups.locations
      let locs = this.lookups.locations
      if (this.member && this.member.service) {
        locs = locs.filter((loc) => {
          return loc.spaces.indexOf(this.member.service) > -1
        })
      }
      return locs
    },
    hours () {
      let hrs = this.lookups.hours
      if (hrs) {
        return hrs.filter((hr) => {
          if (this.practitionerId && this.practitionerId !== hr.practitioner_id) {
            return null
          }
          if (this.member && this.member.service !== hr.space ) {
            return null
          }
          if (hr.addresses && hr.addresses.length === 0) { return null }
          return hr
        })
      }
      return []
    },
    space () {
      return this.getSpaceById(this.spaceId)
    }
  }
}
</script>
